import { DocumentDesignEditor } from "./DocumentDesignEditor";

interface SignatureBlockZoneProps {
  value: string;
  onChange: (next: string) => void;
}

export function SignatureBlockZone({
  value,
  onChange,
}: SignatureBlockZoneProps) {
  return (
    <DocumentDesignEditor
      value={value}
      onChange={onChange}
      height={260}
      uploadType="signature"
    />
  );
}
